function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'dune': 'url("//nomada.sg/cdn/shop/files/Frame_27_68x.png?v=570074199097089985")','cypress': 'url("//nomada.sg/cdn/shop/files/Frame_30_68x.png?v=382826433985551196")','barbary': 'url("//nomada.sg/cdn/shop/files/Frame_29_68x.png?v=9564439415062515880")','teda': 'url("//nomada.sg/cdn/shop/files/Frame_27_68x.png?v=570074199097089985")','atlas': 'url("//nomada.sg/cdn/shop/files/Frame_28_68x.png?v=9598293404437481850")','halo-sepia': 'url("//nomada.sg/cdn/shop/files/Frame_40_bff79baf-031f-4d25-b17a-388c85ccc971_68x.png?v=12921654986763965532")','tenere-bone': 'url("//nomada.sg/cdn/shop/files/Frame_42_ce7b9a8c-c312-444b-9714-839f0c5f26af_68x.png?v=15213332569190383605")','natural-rattan': 'url("//nomada.sg/cdn/shop/files/Frame_39_68x.png?v=17582235702150465754")','olea-bark': 'url("//nomada.sg/cdn/shop/files/Frame_41_a9920504-b88a-4e48-80a8-93c9058c8ba0_68x.png?v=2424679225598097202")','zilla-cloud': 'url("//nomada.sg/cdn/shop/files/Frame_46_68x.png?v=2099765280615761520")','sirocco-cloud': 'url("//nomada.sg/cdn/shop/files/Frame_44_75791eeb-8e23-414a-add9-68cecb6f8efd_68x.png?v=3970604638500066860")','capparis-cloud': 'url("//nomada.sg/cdn/shop/files/Frame_45_68x.png?v=142485706141833188")',};

    this.triggers = ['color','colour','couleur','farbe','cor','color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
